import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META_MAP: Record<string, { title: string; description?: string }> = {
  "/": {
    title: "Salahaldin Daraldik — Software Developer",
    description:
      "Palestinian Software Developer & MSc Data Science student. Full-stack React, Hono, Cloudflare Workers, ML pipelines.",
  },
  "/projects": {
    title: "Projects — Salahaldin Daraldik",
    description:
      "Production-grade projects: Voice2Query, AL-Nema charity system, ALMOTWAKEL olive oil export platform, plus research repos.",
  },
  "/journeys": {
    title: "Journeys — Salahaldin Daraldik",
    description:
      "Long-form timelines of what I'm learning: big data, biotechnology, cloud-native engineering, and everything in between.",
  },
  "/about": {
    title: "About — Salahaldin Daraldik",
  },
  "/contact": {
    title: "Get in touch — Salahaldin Daraldik",
    description: "Reach out about freelance work, research collaboration, or just to say hi.",
  },
};

export function PageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = META_MAP[pathname] ?? { title: "Salahaldin Daraldik" };
    document.title = meta.title;
    if (meta.description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", meta.description);
    }
    // Fire analytics page_view for non-admin public routes.
    if (typeof window !== "undefined" && !pathname.startsWith("/admin")) {
      import("@/lib/api").then(({ trackEvent }) =>
        trackEvent({ eventType: "page_view", path: pathname })
      );
    }
  }, [pathname]);
  return null;
}
